export default __webpack_public_path__ + "static/media/login_cover.21097b3d.svg";